"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgTBankLogo = function SvgTBankLogo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 53 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t-bank-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.221 6.78c-.358-.138-.825-.18-1.334-.18h-2.833v-.88h4.868V4.208h-6.861v6.545h4.647c.647 0 1.128-.055 1.486-.192.756-.29 1.265-.99 1.265-1.912 0-.935-.482-1.581-1.238-1.87Zm-.99 2.268c-.11.041-.261.055-.454.055h-2.723V8.058h2.723c.22 0 .399.014.536.083.165.082.248.233.248.426a.492.492 0 0 1-.33.481ZM33.05 4.208h-2.916l-2.681 6.545h2.255l.371-.949h3.025l.385.95h2.242l-2.682-6.546ZM30.573 8.36l.949-2.64h.151l.949 2.64h-2.049ZM38.297 8.32v2.433h-1.994V4.208h1.994V6.6h3.204V4.208h1.994v6.545H41.5V8.32h-3.204ZM46.651 8.278v2.475h-1.994V4.208h1.994v2.461h.55l2.407-2.461h2.502l-3.19 3.135 3.314 3.41H49.58l-2.379-2.475h-.55Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.424 0H16.32v7.994a5.737 5.737 0 0 1-2.868 4.969l-5.08 2.933-5.08-2.933A5.737 5.737 0 0 1 .424 7.994V0Z",
    fill: "#FFDD2D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.787 4.208v2.486c.34-.384.958-.644 1.665-.644h.768v2.89c0 .77-.209 1.443-.519 1.813h3.342c-.31-.37-.518-1.043-.518-1.81V6.05h.768c.707 0 1.325.26 1.665.644V4.208h-7.17Z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "t-bank-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.424)",
    d: "M0 0h51.826v16H0z"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgTBankLogo);
var _default = exports["default"] = Memo;